import React from 'react';
import { publicationsData } from '../../../data/home/publications';
import ArticleCarousel from '../article-carousel/article-carousel';

const SectorUpdates = () => {
  return (
    <ArticleCarousel 
      title={publicationsData.title}
      description={publicationsData.description}
      slides={publicationsData.publications}
    />
  );
};

export default SectorUpdates;
